module.exports = __webpack_public_path__ + "img/profile-4.e87640a7.png";